<template>
  <div class="my-select" :style="` --backroud:${color};`">
    <div class="my-display-box">
      <div class="select-input" :style="styleCss">
        <div class="left">{{ defaultSelected.name }}</div>
        <div
          class="icon"
          :style="{ transform: `rotate(${rotation}deg)` }"
          @click="handleClick()"
        >
          <img src="@/assets/mybox/home/arrow.png" />
        </div>
      </div>
      <div
        class="selected-list"
        :style="`max-height:${maxHeight}rem;background:${
          maxHeight == 0 ? 'none' : color
        }`"
      >
        <div
          class="selected-item"
          v-for="(item, index) in selectList"
          :key="index"
          @click="selected(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </div>
    <div
      class="my-select-backgroud"
      v-if="isSelected"
      @click="handleClick"
    ></div>
  </div>
</template>
<script>
export default {
  name: "MySelect",
  props: {
    selectList: {
      type: Array,
      default() {
        return [];
      },
    },
    styleCss:{
        type:String,
        default:''
    },
    color:{
        type:String,
        default:'#f3f5f7'
    }
  },
  data() {
    return {
      rotation: 0, //小箭头旋转的角度
      maxHeight: 0,
      isSelected: false, //是否显示下拉框
      defaultSelected: this.selectList[0], //选中的值
    };
  },
  methods: {
    //开关下拉框
    handleClick() {
      if (this.isSelected) {
        this.rotation = 0;
        this.maxHeight = 0;
      } else {
        this.rotation = 180;
        this.maxHeight = 10;
      }
      this.isSelected = !this.isSelected;
    },
    selected(val) {
      this.defaultSelected = val;
      this.$emit("selected", val);
      this.handleClick();
    },
  },
};
</script>
<style lang="scss" scoped>
.my-select {
  width: 100%;
  height: 0.8rem;
  .my-display-box {
    width: 100%;
    position: relative;
    z-index: 2;
    .select-input {
      width: 100%;
      height: 0.8rem;
      display: flex;
      justify-content: space-between;
      background: var(--backroud);
      border-radius: 20px;
      align-items: center;
      padding: 0 0.2rem;
      .left {
        font-size: 0.28rem;
        color: #303030;
      }
      .icon {
        width: 0.2rem;
        height: 0.2rem;
        transition: 0.3s;
        z-index: 2;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .selected-list {
      position: absolute;
      top: 0;
      width: 100%;
      background: none;
      padding: 0.1rem 0.2rem;
      border-radius: 20px;
      max-height: 0rem;
      transition: 0.3s;
      overflow: hidden;
      .selected-item {
        font-size: 0.28rem;
        color: #303030;
        margin: 0.2rem 0rem;
        margin-bottom: 0.3rem;
        text-align: left;
      }
    }
  }
  .my-select-backgroud {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: none;
  }
}
</style>
